import { useLang } from '@/i18n';
import EcoLink from 'eco-design/base/eco-link';
import { useEffect, useRef, useState } from 'react';
import { IconArrow } from './icons';
import css from './index.module.scss';

const K: React.FC = () => {
    const { t } = useLang('dpux');
    const [poster, setPoster] = useState('');
    const [src, setSrc] = useState('');
    const [enter, setEnter] = useState(false);
    const videoRef = useRef<HTMLVideoElement>(null);
    const sources: string[] = [
        'https://websiteoss.ecoflow.com/upload/video/1760001736974/7day.mp4',
        'https://websiteoss.ecoflow.com/upload/video/1760001736974/7day.mp4',
    ];
    const posters = [
        'https://websiteoss.ecoflow.com/upload/image/1760164808869/7day-pc.jpg',
        'https://websiteoss.ecoflow.com/upload/image/1760164808632/7day-m.jpg',
    ];
    const lines = t('K_title').split('\n');
    const [textT, setTextT] = useState(10);
    const href = 'https://us.ecoflow.com/products/installation-service?variant=54527686869065';

    useEffect(() => {
        if (typeof window !== 'undefined') {
            let n = 12;
            if (window.innerWidth >= 1680) {
                n = 14;
            } else if (window.innerWidth >= 1440) {
                n = 14;
            } else if (window.innerWidth >= 1024) {
                n = 11;
            } else if (window.innerWidth < 1024) {
                n = 10;
            }
            setTextT(n);

            const sceneKArr: any[] = [];
            sceneKArr.push(
                AniContainer.create({
                    triggerElement: '.delta-pro-ultra-x-G',
                    triggerHook: 1,
                    onEnter: () => {
                        setSrc(sources[0]);
                        setPoster(posters[0]);
                    },
                }),
            );
            sceneKArr.push(
                AniContainer.create({
                    triggerElement: '.delta-pro-ultra-x-K',
                    triggerHook: 1,
                    offset: '100%',
                    duration: '50%',
                    asyncFromTo: [
                        [`.delta-pro-ultra-x-K .icon-ani`, { scale: 0.2 }, { scale: 0.5 }, 0.2],
                        [`.delta-pro-ultra-x-K .video-box`, { opacity: 0 }, { opacity: 0 }, 0.2],
                        [`.delta-pro-ultra-x-K .icon-ani`, { opacity: 1, scale: 0.5 }, { opacity: 0, scale: 1 }, 0.2],
                        [`.delta-pro-ultra-x-K .tip`, { opacity: 1 }, { opacity: 0 }, 0.2],
                        [`.delta-pro-ultra-x-K .video-box`, { opacity: 0 }, { opacity: 1 }, 0.2],
                        [`.delta-pro-ultra-x-K .icon-ani`, { opacity: 0, scale: 1 }, { opacity: 0, scale: 1 }, 0.1],
                        [`.delta-pro-ultra-x-K .tip`, { opacity: 0 }, { opacity: 0 }, 0.1],
                        [`.delta-pro-ultra-x-K .video-box`, { opacity: 1 }, { opacity: 1 }, 0.1],
                    ],
                    asyncTimeLine: [0, 0, 0.2, 0.2, 0.2, 0.4, 0.4, 0.4],
                }),
            );
            sceneKArr.push(
                AniContainer.create({
                    triggerElement: '.delta-pro-ultra-x-K',
                    triggerHook: 1,
                    offset: '135%',
                    duration: '125%',
                    onEnter: () => {
                        if (videoRef?.current) {
                            videoRef.current.currentTime = 0;
                            videoRef.current.play();
                        }
                    },

                    onProcess: (process: number) => {
                        if (process <= 0 && videoRef?.current) {
                            videoRef.current.currentTime = 0;
                            videoRef.current.pause();
                        }
                    },
                }),
            );
            sceneKArr.push(
                AniContainer.create({
                    triggerElement: '.delta-pro-ultra-x-K',
                    triggerHook: 1,
                    offset: '140%',
                    duration: '120%',
                    onEnter: () => setEnter(true),
                    onProcess: (process: number) => {
                        if (process <= 0) {
                            setEnter(false);
                        }
                    },
                }),
            );

            return () => {
                sceneKArr.forEach((item) => {
                    item.destroy();
                });
            };
        }
    }, []);

    return (
        <section
            className={`${css.section} delta-pro-ultra-x-K dpux-K GtmModuleData-section`}
            id="delta-pro-ultra-x-K"
            data-section-id={'delta-pro-ultra-x-K'}
            data-section-title={t('K_title')}
        >
            <div className="sticky">
                <div className="video-box">
                    {src && <video ref={videoRef} src={src} muted width="100%" height="100%" preload="metadata" poster={poster} loop playsInline></video>}

                    <EcoLink
                        className={`btn${enter ? ' enter' : ''} GtmModuleData-btn-href`}
                        href={href}
                        dataLayer={{
                            __btn_id1: `dpux-K .btn`,
                            __btn_id2: href,
                            __btn_type: 'href',
                        }}
                    >
                        <span>{t('K_link')}</span>
                        <span className="hide">{'About Installation Service'}</span>
                        {IconArrow}
                    </EcoLink>
                </div>
                <div className="icon-box">
                    <div className="icon-ani">
                        <svg width="100%" height="100%" style={{ transform: 'scale(5)' }}>
                            {/* 黑色背景 */}
                            <rect width="100%" height="100%" fill="black" />

                            {/* 实心白字（不镂空） */}
                            {lines.map((line: string, index: number) => (
                                <text
                                    className={`svg-text svg-text-${index + 1}`}
                                    key={index}
                                    x="50%"
                                    y={`${50 + (index - (lines.length - 1) / 2) * textT}%`}
                                    textAnchor="middle"
                                    dominantBaseline="middle"
                                    fill="white" // ← 实心白色文字
                                    fontSize="24" // 可按需调整（px 或 SVG 单位）
                                    fontWeight="700"
                                >
                                    {line}
                                </text>
                            ))}
                        </svg>
                    </div>
                    <div className="tip">{t('tip')}</div>
                </div>
            </div>
        </section>
    );
};

export default K;
